import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { firstValueFrom } from 'rxjs';
import { SubscriberUpdateDto } from 'src/app/shared/dtos/subscribe/subscriberUpdateDto';
import { DefinationService } from 'src/app/shared/services';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { SubscribeService } from 'src/app/shared/services/subscribe.service';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss'],
})
export class SubscribeComponent implements OnInit {
  constructor(
    private subscribeService: SubscribeService,
    private loadingService: LoadingService,
    private notificationService: NotificationService,
    private definationService: DefinationService
  ) {}

  subscribers = {} as CustomStore;
  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid!: DxDataGridComponent;
  emailList:string[]=[]
  templateName:string=''
  templateNames:any



  ngOnInit(): void {
    this.getList();
    this.getSmtpName()
  }

  async getList() {
    this.subscribeService.getListSubscriber().then((dataSource) => {
      this.subscribers = dataSource;
    });
  }

  async getSmtpName(){
    this.templateNames = await firstValueFrom(this.definationService.getSmtpName())
  }

  async updateSubscribe(event: any) {
    this.loadingService.show();
    if (event.newData) {
      var subscriberUpdateDto: SubscriberUpdateDto = {
        id: event.oldData.id,
        email: event.newData.email ?? event.oldData.email,
        isSubscriber: event.newData.isSubscriber ?? event.oldData.isSubscriber,
      };
      await firstValueFrom(
        this.subscribeService.update(
          subscriberUpdateDto.id,
          subscriberUpdateDto
        )
      );
      await this.getList();
      this.dataGrid.instance.refresh();
      this.notificationService.show('Başarı ile güncellendi.');
    }
    this.loadingService.hide();
  }

  async sendSubscriberMail() {
    if(this.emailList.length <= 0){
      this.notificationService.showError('En az bir kayıt seçiniz')
      return
    }
    
    if(this.templateName == ''){
      this.notificationService.showError('Şablon seçmeden devam edilemez')
      return
    }


    this.loadingService.show();
    await firstValueFrom(this.subscribeService.sendSubscriberMail(this.emailList, this.templateName));
    this.notificationService.show('Mail gönderme başarı ile tamamlandı');
    this.loadingService.hide();
  }

  onSelectionChanged(event:any){
    this.emailList = event.selectedRowsData.map((item:any) => item.email);
  }

  getRowNumber(rowIndex: number): number {
    const pageIndex = this.dataGrid.instance.pageIndex(); // Mevcut sayfa numarası
    const pageSize = this.dataGrid.instance.pageSize(); // Sayfa başına kayıt sayısı
    return pageIndex * pageSize + rowIndex + 1;
  }
}
